<template>
  <div id="app">
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <deep-run />
  </div>
</template>

<script>
import DeepRun from './components/DeepRun.vue'

export default {
  name: 'App',
  components: {
    DeepRun
  }
}
</script>

<style>

</style>
